// Test deployment 5 - Added on Dec 24, 2024
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './components/Login';
import OperatorDashboard from './components/dashboard/OperatorDashboard';
import LocationList from './components/locations/LocationList';
import ChargePointList from './components/chargePoints/ChargePointList';
import OperatorSettings from './components/operators/OperatorSettings';
import AdminDashboard from './components/dashboard/AdminDashboard';
import Operators from './components/admin/Operators';
import VendorList from './components/admin/VendorsManagement';
import AdminSettings from './components/admin/AdminSettings';
import RFIDTagList from './components/rfidTags/RFIDTagList';
import TransactionList from './components/transactions/TransactionList';
import UserList from './components/users/UserList';
import AreasMenu from './components/admin/AreasMenu';
import PendingImagesManager from './components/admin/PendingImagesManager';
import NotificationManager from './components/admin/NotificationManager';
import './i18n'; // Import i18n configuration

const ProtectedRoute = ({ children, allowedRoles }: { children: React.ReactNode, allowedRoles: string[] }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role;

  // If no token, redirect to login
  if (!token) {
    return <Navigate to="/login" />;
  }

  // If user has a role but not allowed for this route
  if (role && !allowedRoles.includes(role)) {
    // Redirect based on role
    if (role === 'operator') {
      return <Navigate to="/operator/dashboard" />;
    }
    if (role === 'admin') {
      return <Navigate to="/admin/dashboard" />;
    }
  }

  // If no role or invalid role, redirect to login
  if (!role) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Layout isAdmin={true}>
                <Routes>
                  <Route path="/" element={<Navigate to="/admin/dashboard" />} />
                  <Route path="/dashboard" element={<AdminDashboard />} />
                  <Route path="/operators" element={<Operators />} />
                  <Route path="/vendors" element={<VendorList />} />
                  <Route path="/locations" element={<LocationList />} />
                  <Route path="/charge-points" element={<ChargePointList />} />
                  <Route path="/transactions" element={<TransactionList />} />
                  <Route path="/users" element={<UserList />} />
                  <Route path="/rfid-tags" element={<RFIDTagList />} />
                  <Route path="/areas" element={<AreasMenu />} />
                  <Route path="/pending-images" element={<PendingImagesManager />} />
                  <Route path="/settings" element={<AdminSettings />} />
                  <Route path="/notifications" element={<NotificationManager />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/operator/*"
          element={
            <ProtectedRoute allowedRoles={['operator']}>
              <Layout isAdmin={false}>
                <Routes>
                  <Route path="/" element={<Navigate to="/operator/dashboard" />} />
                  <Route path="/dashboard" element={<OperatorDashboard />} />
                  <Route path="/locations" element={<LocationList />} />
                  <Route path="/charge-points" element={<ChargePointList />} />
                  <Route path="/transactions" element={<TransactionList />} />
                  <Route path="/users" element={<UserList />} />
                  <Route path="/rfid-tags" element={<RFIDTagList />} />
                  <Route path="/settings" element={<OperatorSettings />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/"
          element={
            <Navigate to="/login" />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
